import { Component, OnInit } from '@angular/core';
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import {ServicioLoadersAlertasService } from '../servicio-loaders-alertas.service'
import * as firebase from 'firebase'
import { Router } from '@angular/router';
import {TimelineComponent} from '../timeline/timeline.component'

@Component({
  selector: 'app-paso2page',
  templateUrl: './paso2page.page.html',
  styleUrls: ['./paso2page.page.scss'],
})
export class Paso2pagePage implements OnInit {
  unidadDeNegocio=''
  descripcionPTW=''
  observaciones=''
  

  constructor(public granServicioDePTWService:GranServicioDePTWService, public servicioLoadersAlertasService:ServicioLoadersAlertasService,private router:Router,public timelineComponent:TimelineComponent ) { }

  ngOnInit() {}

  ionViewWillEnter(){
    this.timelineComponent.actualizar()
    if(this.granServicioDePTWService.solicitudEsNueva==false){
      this.granServicioDePTWService.cargadatosdePTW((res)=>{
        this.unidadDeNegocio = res.data().unidadDeNegocio
        this.descripcionPTW = res.data().descripcionPTW
        if(res.data().observaciones!= undefined){
          this.observaciones=res.data().observaciones
        }
        
      })
    }
  }

continuar(){
  if(this.unidadDeNegocio == ''||this.descripcionPTW==''){
    this.servicioLoadersAlertasService.alerta("Campos incompletos","Seleccione una unidad de negocio e ingrese la descripción de la actividad a realizar.")
  }else
  if(this.unidadDeNegocio!=''&&this.descripcionPTW!=''){
    this.updateFirebase()
  }
}


  updateFirebase(){

  firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
    unidadDeNegocio:this.unidadDeNegocio,
    descripcionPTW:this.descripcionPTW,
    observaciones:this.observaciones,
    "objetoPasosCompletados.paso2":"ok" //---->poniendo entre comillas y con dot notation podemos actualizar valores dentro de objetos
    }).then((doc)=>{
      this.servicioLoadersAlertasService.presentToast("Actividad y unidad de negocio guardadas. Continúe con el siguiente paso.")
      // this.timelineComponent.avanzar('2')
      this.navegar("/paso3page")
    }).catch((err)=>{
      this.servicioLoadersAlertasService.alerta("Error",err);
    })
  }

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 

 regresar(){
  this.navegar("/paso1page")
 }
 
 volveramenu(){
  this.navegar("/menu")
 }


}
